import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import LiveHeadline from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Headline") {
    return [LiveHeadline];
  }
};
